<template>
    <div class="container-fluid container-app-config">
    <div class="row">
      <div class="col-12">
        <SelectImage :edicion="true" @on-set-file="onSetFoto">
          <Image :src="imgAvatar.img" v-if=" imgAvatar && imgAvatar.img" width="100" height="100" class="profile-img-2b"/>
          <img src="../../assets/img/avatar2.png" class="profile-img-2" v-else>
          
        </SelectImage>                  
      </div>      
    </div>
    <div class="row mt-1">
      <div class="col-12">
            <span class="spn-name">
                {{ sesion.FullName }}
            </span>
          </div>
    </div>
    <div class="row mt-3">
      <div class="form-group col-12  control-container-2">
        <label class="form-label">{{ $t('AppConfig.Lang') }}</label> 
        <Dropdown v-model="idioma" :options="languagesLst"  optionLabel="title"        
                  class="w-100 vb-control vb-control-dropdown">
            <template #value="slotProps">
                <div :class="`languageIco ${slotProps.value.logo}`" v-if="slotProps.value">           
                    <span >{{slotProps.value.title}}</span>
                </div>        
            </template>
            <template #option="slotProps">
                <div :class="`languageIco ${slotProps.option.logo}`" >           
                    <span >{{slotProps.option.title}}</span>                                
                </div>
            </template>
          </Dropdown>
      </div>      
    </div>
    <div class="row mt-2">
      <div class="form-group col-12  control-container">
        <div class="mt-1">
          <label class="form-label">{{ $t('AppConfig.Tema') }}</label> 
            <input id="chkTogleTheme1" type="checkbox" class="switch-checkbox" @change="changeTheme"/> 
            <label for="chkTogleTheme1" class="switch-label">
              <span>🌙</span>
              <span>☀️</span>
              <div class="switch-toggle"
                  :class="{ 'switch-toggle-checked': userTheme === 'dark_Default' }">
              </div>
            </label>  
          </div>
      </div>
    </div>
    <div class="row mt-5">
            <div class="form-group">
                <div class="centerButton">
                    <Button type="button" @click="SaveAppOptions">
                        {{ $t('globals.aceptar')}}
                    </Button>
                </div>
            </div>
        </div> 
  </div>
</template>
<script  setup lang="ts">
import { PropType, defineProps, ref, defineEmits, onMounted } from 'vue';
import { ISesionApp } from '@/core/model/sesion/ISesionApp';
import Dropdown from 'primevue/dropdown';
import {languagesLst} from '@/i18n';
import AppSystemSettingsService, { IAppUserSettings } from '@/core/services/sys/AppSystemSettingsService';
import { useServicesFactoryStore } from '@/core/stores/services-factory-store';
import {  eThemesNames } from '@/core/model/GloblasEnum';
import Button from 'primevue/button';
import SelectImage from './SelectImage.vue';
import { IsMimeImageValid, traduceTexto } from '@/core/services/base/GlobalFunctios';
import AppUIManagerService from '@/core/services/AppUIManagerService';
import { FileUp } from '@/core/model/IFileData';
import Image from 'primevue/image';
import LoginService from '@/core/services/login/LoginService';
import { useI18n } from 'vue-i18n';
import moment from 'moment';
import { usePrimeVue } from 'primevue/config';
import jsonLangEsDefault from '@/locales/es.json';
import jsonLangEnDefault from '@/locales/en.json';

const uiManager:AppUIManagerService = useServicesFactoryStore().getAppUIManagerService;
const appSettingsService:AppSystemSettingsService = useServicesFactoryStore().getAppSystemSettingsService
const loginService:LoginService = useServicesFactoryStore().getLoginService;
const currentLang = useI18n();
const primevue = usePrimeVue();
//const settingTheme:IAppSystemSettings = appSettingsService.getSettingByName(eSettingsNames.theme);
//const settingLanguage:IAppSystemSettings = appSettingsService.getSettingByName(eSettingsNames.language);

const imgAvatar = ref<any>(null);
let userTheme = ref<string>('');
let idioma = ref<any>(null);
const props = defineProps(
{
    sesion: { type: Object as PropType<ISesionApp>, required:true }
});
const emits = defineEmits(['onSave']);
const labels={
    imgNoValid :traduceTexto('globals.ImagenNoValida')
}
const changeTheme = ()=>
{
  const activeTheme = userTheme.value.split('_')[0].toLowerCase();    
  if (activeTheme === "light" || !activeTheme)       
    userTheme.value = eThemesNames.dark;      
  else 
    userTheme.value = '';   
}
const toggleTheme = () =>
{  
  const activeTheme = userTheme.value.split('_')[0].toLowerCase();    
  if (activeTheme === "light" || !activeTheme)
  {     
    setTheme('');//(eThemesNames.light); 
    primevue.changeTheme('lara-dark-blue','lara-light-blue', 'site-theme-link');    

  }
  else 
  {
    setTheme(eThemesNames.dark);
    primevue.changeTheme('lara-light-blue','lara-dark-blue', 'site-theme-link');    
  }
}

const setTheme = (theme:string) =>
{
/*https://medium.com/@dgongoragamboa/añadir-darkmode-a-un-proyecto-de-vue-3679af55b642 */
 // userTheme.value = theme;
  //document.documentElement.className = theme;
  document.documentElement.setAttribute('data-theme', theme);
  //localStorage.setItem("user-theme", theme);  
  //console.log(document.documentElement);
  //document.documentElement.className = theme;
}
const onSetFoto = (foto: any) =>
{
    if (foto)
    {
      const valid = IsMimeImageValid(foto.type);
      if (!valid)
      {
        uiManager.showError(labels.imgNoValid);
      }
      else
      {
        const reader = new FileReader();
        reader.onload = (e: any) =>
        {                          
          AddGaleria(foto, e.target.result);
        };
        reader.readAsDataURL(foto);                    
      }
    }
}
const AddGaleria = (foto: FileUp, img: string) =>
{
  imgAvatar.value =
  {        
    name: foto.name,
    img: img
  };    
}
const SaveAppOptions = async()=>
{
  const sesion:ISesionApp = await loginService.getSession();
  const settings:IAppUserSettings = {
    profileImg:imgAvatar.value && imgAvatar.value.img? imgAvatar.value.img.split(',')[1]:null,
    theme:userTheme.value,
    language:idioma.value.id
  };
  uiManager.loadingUi();  
  await appSettingsService.SaveAppOptions(sesion.Employee?.User.Gid, settings);
  await loginService.SaveAppSettings(settings);
  uiManager.loadingUi();  
  changeLanguage();
  toggleTheme();
  emits('onSave',settings); 
}

const changeLanguage = ()=>
{  
  //$i18n.locale = idioma.id;
  currentLang.locale.value = idioma.value.id;
  moment.locale(idioma.value.id);  
  switch(idioma.value.id)
  {
    case 'es-mx':
      primevue.config.locale = {...jsonLangEsDefault.prime};
      break;
    case 'en-us': 
      primevue.config.locale = {...jsonLangEnDefault.prime};
      break;
  }  
}
onMounted(async ()=>
{               
  const appSettings = await loginService.getAppSettings();            
  imgAvatar.value ={img: appSettings.profileImg? 'data:image/png;base64,' +  appSettings.profileImg:null};
  idioma.value = languagesLst.find((x:any)=>x.id === appSettings.language);
  userTheme.value = props.sesion.Employee?.User.Theme? appSettings.theme:'';  
});
</script>
<style scoped>
.profile-img-2
{
  width: 100px;
  height: 100px;
  display: block;
  margin: auto;
  object-fit: contain;   
}
.languageIco
{     
  background-position: left;
  background-repeat: no-repeat;
  background-size: 28px;   
}
.languageIco span
{
  margin-left: 35px;
}
.es-mx
{
 background-image: url('data:image/jpeg;base64,/9j/4AAQSkZJRgABAQEAYABgAAD/2wBDAAIBAQIBAQICAgICAgICAwUDAwMDAwYEBAMFBwYHBwcGBwcICQsJCAgKCAcHCg0KCgsMDAwMBwkODw0MDgsMDAz/2wBDAQICAgMDAwYDAwYMCAcIDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAz/wAARCAAcADIDASIAAhEBAxEB/8QAHwAAAQUBAQEBAQEAAAAAAAAAAAECAwQFBgcICQoL/8QAtRAAAgEDAwIEAwUFBAQAAAF9AQIDAAQRBRIhMUEGE1FhByJxFDKBkaEII0KxwRVS0fAkM2JyggkKFhcYGRolJicoKSo0NTY3ODk6Q0RFRkdISUpTVFVWV1hZWmNkZWZnaGlqc3R1dnd4eXqDhIWGh4iJipKTlJWWl5iZmqKjpKWmp6ipqrKztLW2t7i5usLDxMXGx8jJytLT1NXW19jZ2uHi4+Tl5ufo6erx8vP09fb3+Pn6/8QAHwEAAwEBAQEBAQEBAQAAAAAAAAECAwQFBgcICQoL/8QAtREAAgECBAQDBAcFBAQAAQJ3AAECAxEEBSExBhJBUQdhcRMiMoEIFEKRobHBCSMzUvAVYnLRChYkNOEl8RcYGRomJygpKjU2Nzg5OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6goOEhYaHiImKkpOUlZaXmJmaoqOkpaanqKmqsrO0tba3uLm6wsPExcbHyMnK0tPU1dbX2Nna4uPk5ebn6Onq8vP09fb3+Pn6/9oADAMBAAIRAxEAPwD6S/b8/a5+Jvwz/bH8eaH4f8ceItI0ewvIRb2drdtHFDvtYZG2gdMu7MfdjXkH/Defxl/6KV4u/wDA9q2v+Cmv/J+XxI/6/bb/ANIrevCq+XxNaoq0kpPd9T+RuJc4x8M3xUIV5pKpNJKUrL3n5n7nfsZ+IL7xz+yx4K1nWb+8v9SvtNWa5up7hy8rbmyzHPtXoWjatpXiNZDp+ow3whcxyG3vfN8thwQcMcGvgLxJ8W5L/wD4J9eE/CNrBf2so0uOOS4W+js8u4cxESmVVVCTgiUqHAYKcjI+f/8AglPF4z+AXx2ude1DVNQjslkls9b0mSRJLbUA2wRPb3IkNvLIGZMqGDcqfmBJFYrPauHxdDCxpOUZrWWyX36Pva97dD+ueGMNRxWSrE1ayU4Qjo9XL3U297/O2/U4P4yft9/GjQviz4lsrP4leLLe1tNTuIoYkvW2xosjAAewFcvc/wDBRL44rbSEfFHxgCFJH+nN6Vw/x1kMvxo8VMVKFtVuSVbqv7xuDXIXf/HrJ/uH+Vfzric5zBYiaVee7+1Lv6n+tWW8HZBLA0pSwNG/JH/l1Dsv7p/S5RRRX9YH+Sp+KH/BTX/k/L4kf9ftt/6RW9eFV+ynxI/4Jm/C34//ABA1nxf4is9Zk1nWLtzcvBqLxRt5Z8lcKBgfJGtYn/Dmv4Jf9A/xD/4Nn/wrwK+BqSqykmtWz+c888OsyxWY4jE05wtOcpK7lezk3r7pN8AP2ZfD/wC0J+xJ8O4tUe+s7hNHEQubOdonKFydrYIzjHByCpJwRmuu/Z2/YB8J/s93f2mK81TW7oT/AGlZLyU4EmWO4rnBPzd+MqDjPNeq/DP4Zaf8JPAel+G9Ge6i0vR4Rb2ySOJGVASeWIyetbv2dv8AnvL+S/4V7EaMbRclqv8Agf5L7kfvmWYZ0cFSoT3jGKfa6Vrn87Px7/5Lb4t/7C9z/wCjWrjrv/j1k/3D/Kv2x8S/8EaPgj4s8Q3up3mneIHu9Qne4mZdWkUF2JJwMccmqD/8ERfgPIhU6Z4jwRg/8TiT/CvwGv4d5lKtKanDVt7y7/4T/SXBfSG4cp4SnSlRr3UUvhp9Fb/n4fXVFFFf0Kf51H//2Q==');
}
.en-us
{
  background-image: url('data:image/jpeg;base64,/9j/4AAQSkZJRgABAQEAYABgAAD/2wBDAAIBAQIBAQICAgICAgICAwUDAwMDAwYEBAMFBwYHBwcGBwcICQsJCAgKCAcHCg0KCgsMDAwMBwkODw0MDgsMDAz/2wBDAQICAgMDAwYDAwYMCAcIDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAz/wAARCAA0AEsDASIAAhEBAxEB/8QAHwAAAQUBAQEBAQEAAAAAAAAAAAECAwQFBgcICQoL/8QAtRAAAgEDAwIEAwUFBAQAAAF9AQIDAAQRBRIhMUEGE1FhByJxFDKBkaEII0KxwRVS0fAkM2JyggkKFhcYGRolJicoKSo0NTY3ODk6Q0RFRkdISUpTVFVWV1hZWmNkZWZnaGlqc3R1dnd4eXqDhIWGh4iJipKTlJWWl5iZmqKjpKWmp6ipqrKztLW2t7i5usLDxMXGx8jJytLT1NXW19jZ2uHi4+Tl5ufo6erx8vP09fb3+Pn6/8QAHwEAAwEBAQEBAQEBAQAAAAAAAAECAwQFBgcICQoL/8QAtREAAgECBAQDBAcFBAQAAQJ3AAECAxEEBSExBhJBUQdhcRMiMoEIFEKRobHBCSMzUvAVYnLRChYkNOEl8RcYGRomJygpKjU2Nzg5OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6goOEhYaHiImKkpOUlZaXmJmaoqOkpaanqKmqsrO0tba3uLm6wsPExcbHyMnK0tPU1dbX2Nna4uPk5ebn6Onq8vP09fb3+Pn6/9oADAMBAAIRAxEAPwDlfFH7eP7VPg3wj4b1q7+LniFrLxXbzXVh5F5YXE7xxEh2kijQvERjOHA457HCeLv29f2qPBGgeHtSvvi7rzWviaze+s/s17Y3MixISGMqRozREABsOAcEe+Ob+GsLfDC38Ca4rTfBg6xoGpj/AIS2Jn1ZvFGCVCfZ8t5ILfuSduBncSoHEvhRW+FuneGtTD3PwabX/Bt6W15d2sS+MMs2FMWW8jzD+7J6ADO4Dgfurw2EX/LiHX7K139ey2u+6R4fPPuze8dft7/tU/Dqx0O41L4t6/5fiHTl1W0+y31hdsIDnBkESsYzgAkPggMM98J8Qv2/P2p/hbJpaax8XNfV9Y02LVoFtb6wvNtvJwrSeSrbDkgENggnmsHSGl+EWn20yPc/Bn/hIfAErfao2OrP433vkcZb7N5xBAPy7Ah+YZplzLL8HtMvI7eSX4NjxD8PUZoIw2rHxt5nPUsfsvn8sCcBNhG/kZf1XCXVqEP/AAFfpf8ADm87Bzz7s93/AGc/jz+1v8Qv2jND8C3PxM1G61LXtHOs20L6nYTwNAYTKGMkKsFcbWUqTnKnjHJ+rP8AhTn7YQ/5nNP/AAcQf/G6+GP2Wfgd4t1f9tTwfoXgnRz8KfEWpeExqCSNrEshvka0Znu1lXcyLOi5CdiWG419yt+xR+0kzE/8Lb68/wDIwX3/AMar8a8QMNCOYwdGnJJwT9xqK3l0Ttf5s/c/DjG0aeVuNWvhIPnelek5z2XVJ+72XqO/4U7+2F/0Oaf+DiD/AON0f8Kd/bC/6HNP/BxB/wDG6b/wxN+0j/0Vv/y4L7/41R/wxN+0j/0Vv/y4L7/41Xw3sp/yVf8AwL/gn3/9pYT/AKCsu/8ACeX/AMiO/wCFO/tg/wDQ5xn2OsQf/G6kHwT/AGwMf8jzEmedp1aH/wCN1D/wxP8AtJKMj4tZPYf8JBff/GqF/Yw/aUC/8lVf/wAKS9/+N0KlPrCp/wCBf8EzqZlhGrfW8u/8EP8A+RPzj+Fs0fgJfAeqWSH4YXN/oOprL4k8TRf2lpviAnKBbaBomWPOfLzg4yGyKf4MiX4dWXhvULMT/DKbVfB98ZNZ8TxjUbXxOWLIPssRiYQlzlAeoHIPPP0/ef8ABvJ4v1Kztbe4+L+hz29ipS2ilsp2S2VjlggMhCgnkgY5p1//AMG8vjDVba3huvjBolzDZp5dvHLZzusC/wB1AZMKOOgr+jnxBlMneVda+UvPutd+t0uiR/K/1SuvsM+XNDRPAGm281pv+F39teBJvOuvFkQ1FfFBZsH7EphPkGQjCEcqFyG55YHXwBYX8enxy/C8az4AQzxeLI/7Qk8UlmUt9hJhPkeZgsh4IKkbua+ptR/4N5/GGrRW6Xfxf0O6S1jEMAlsZnEKDoi5f5VHoOKNS/4N5vGOvND9r+L+h3Zt4lt4fPspn8qNc7UXMnCjJwBwM0f6wZT1xC89H8t1r8726C+q1/5WeIfstfBXW/G37Z3g/QfBVl4m+GGs3fhT7V52tanI010fszyPPG6KrLFKuMLzglhk19x/8O+fjuP+avXP/g81D/CvMvht/wAELvHXgLx5a66/xgsLi6s7RrW3lSKdJYo8bRGreZlUClsKOBnpzXqR/wCCZvxDz/yV2X/v/df/AByvyPjnEUsZj41cOnUSgldSa1u+7ufuHh3mccHlbpVsbSoPnb5Z0PaS2WvNZ6eRF/w76+O//RXrn/weah/hR/w76+O//RXrn/weah/hUv8Aw7O+If8A0V2X/v8A3X/xyj/h2d8Q/wDorkv/AH/uv/jlfGfV5f8APmX/AIH/AME+8/1jof8AQ1w//hJ/9qRN/wAE+vjvj/kr1z/4PNQoj/4J9/HRUAb4wXRbuf7e1GpT/wAEzfiGR/yV2X/v/df/ABymP/wTK+IZY/8AF35OTni5uv8A45TWHl/z5l/4H/wRPiSgts2w/wD4Sf8A2o3/AIdU63j/AJK43/fmT/4/QP8AglTrf/RXG/78yf8Ax+oB/wAErdF/6K9Acdf3MX/x6k/4dZaF/wBFftf+/UP/AMeqfqf/AFD/APk5r/rSv+h1/wCWa/yLP/DqnW/+iuN/35k/+P0D/glTrY/5q43/AH5k/wDj9Vv+HWWhf9Fftf8Av1D/APHqP+HWWhf9Fftf+/UP/wAeo+p/9Q//AJOH+tK/6HX/AJZr/Isn/glVrbf81bP/AH4fn/yNR/w6p1s/81cb/vzJ/wDH6rf8OstC/wCiv2v/AH6h/wDj1H/DrLQv+iv2v/fqH/49T+p/9Q//AJOH+tK/6HX/AJZr/Is/8OqNb/6K43/fmT/4/R/w6o1v/orjf9+ZP/j9Vv8Ah1loX/RX7X/v1D/8eo/4dZaF/wBFftf+/UP/AMepfU/+of8A8nD/AFpX/Q6/8s1/kWf+HVGt/wDRXG/78yf/AB+j/h1RrX/RXH/CJ/8A49VYf8EsdCJ/5LBa/wDfqH/49Sf8OrNE/wCix2/4JF/8eprB/wDUP/5OJ8Uf9Tr/AMs/+Ae2/wDDkH4V/wDQyfEX/wADrL/5Eo/4chfCv/oZPiJ/4G2X/wAiUUVn7Cl/KvuPUWdZh/z/AJ/+BS/zD/hyF8K/+hk+In/gbZf/ACJR/wAOQvhX/wBDJ8RP/A2y/wDkSiij2FL+VfcP+2sw/wCf8/8AwKX+Yf8ADkL4V/8AQyfET/wNsv8A5Eo/4chfCv8A6GT4if8AgbZf/IlFFHsKX8q+4P7azD/n/P8A8Cl/mH/DkL4V/wDQyfET/wADbL/5Eo/4chfCv/oZPiJ/4G2X/wAiUUUewpfyr7g/trMP+f8AP/wKX+Yf8OQfhWf+Zk+In/gbZf8AyJSf8OPvhT/0MfxF/wDA+z/+RaKKaoU7/CvuOetnWY/8/wCf/gUv8z//2Q==')
}

.switch-checkbox {
    display: none;
  }

  .switch-label {
    /* for width, use the standard element-size */
    width: 4rem; 
  
    /* for other dimensions, calculate values based on it */
    border-radius: var(--element-size);
    border: calc(var(--element-size) * 0.025) solid var(--accent-color);
    padding: 0;
    font-size: calc(var(--element-size) * 0.3);
    height: calc(var(--element-size) * 0.55);
  
    align-items: center;
    background: var(--bg-color-blix);
    cursor: pointer;
    display: flex;
    position: relative;
    transition: background 0.5s ease;
    justify-content: space-between;
    z-index: 1;
  } 
  .switch-toggle 
  {
    position: absolute;
    background-color: var(--background-slider);    
    border-radius: 50%;
    top: calc(var(--element-size) * 0.07);
    left: calc(var(--element-size) * 0.07);
    height: calc(var(--element-size) * 0.4);
    width: calc(var(--element-size) * 0.4);
    transform: translateX(0);
    transition: transform 0.3s ease, background-color 0.5s ease;
  }

  .switch-toggle-checked {
    transform: translateX(calc(var(--element-size) * 0.45)) !important;
  }
</style>